// Remove HTML tags from string
export const cleanString = (str?: string): string => {
    return str ? str.replace(/(<([^>]+)>)/gi, '') : '';
};
